import { render } from "./ContainerShell.vue?vue&type=template&id=5f39ac36"
import script from "./ContainerShell.vue?vue&type=script&lang=js"
export * from "./ContainerShell.vue?vue&type=script&lang=js"

import "./ContainerShell.vue?vue&type=style&index=0&id=5f39ac36&lang=scss"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__